const ids = [];
export function resetIds() {
  ids.length = 0;
}

/**
 * Creates a random string of 10 characters
 * @returns {string}
 */
export function generateContentId() {
  let id = '';
  while (id.length < 10) {
    const randomChar = Math.random().toString(36).substring(2, 3);
    id += Math.random() > 0.5 ? randomChar.toUpperCase() : randomChar;
  }
  const outputId = id.substring(0, 10);
  if (!ids.includes(outputId)) {
    ids.push(outputId);
    return outputId;
  }
  return generateContentId();
}